import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M9.06 6.94a1.5 1.5 0 010 2.12m-2.12 0a1.5 1.5 0 010-2.12m3.535-1.415a3.499 3.499 0 010 4.95m-4.949 0a3.499 3.499 0 010-4.95M11.89 4.11a5.5 5.5 0 010 7.78m-7.779 0a5.5 5.5 0 010-7.78"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.59 10.41a2.25 2.25 0 010 3.181m-3.181-.001a2.25 2.25 0 010-3.181m5.301-2.121a5.248 5.248 0 010 7.424m-7.423 0a5.248 5.248 0 010-7.424m9.547-2.122a8.25 8.25 0 010 11.668m-11.668 0a8.25 8.25 0 010-11.668"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.182 20.819a4.499 4.499 0 010 6.364m-6.364-.001a4.499 4.499 0 010-6.364m10.606-4.242c4.102 4.1 4.102 10.748 0 14.848m-14.848 0c-4.101-4.1-4.101-10.748 0-14.848m19.092-4.244c6.444 6.446 6.444 16.89 0 23.336m-23.336 0c-6.444-6.446-6.444-16.89 0-23.336"
  }))
};
export var AudioFeedback = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});